import { React, useEffect, useState } from 'react';
import GeoGebraMySolAnimation from '../components/GeoGebraMySolAnimation';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import '../App.css';

const DifficultyProblemMySolAnimation = ()=> {
    const navigateto=useNavigate();
    const {dcProbIDMy}=useParams();
    const {difficultyCategoryCode, problemCode, difficultyCategoryTitle, problem, useStat, myAnswerList, myPointConstruction, isFirst, isLast, prevProblem, prevUrlAdd, nextProblem, nextUrlAdd, dcProbID, myConstructionStep, myAnswerRaw, dcPhase} = useLocation().state;
    const [randomString1, setRandomString1] = useState();

    useEffect(() => {
        const revivalData = () => {
            const letters = '1234567890';
            let randomString1l = '';
            for (let i = 0; i < 3; i++) {
                randomString1l += letters[Math.floor(Math.random() * letters.length)];
            }
            setRandomString1(randomString1l);
        };
        revivalData();
    },[dcProbIDMy])

    return(
        <div className="problem" key={myAnswerRaw.answerMark}>
            <div className="content-fit">
                <h4>{myAnswerRaw.solvingTime.substring(6,10)}년 {myAnswerRaw.solvingTime.substring(3,5)}월 {myAnswerRaw.solvingTime.substring(0,2)}일 {myAnswerRaw.solvingTime.substring(12,17)}의 풀이</h4>
                <GeoGebraMySolAnimation
                    idIn={problem.problemCode}
                    customToolBarIn={problem.customToolBar}
                    allowStyleBarIn={problem.allowStyleBar}
                    ggbBase64In={problem.problemContent}
                    myPointAnswer={myPointConstruction}
                    myAnswerStep={myConstructionStep}
                    problemType={problem.problemType}
                />
                <div className='horizontal-flex-container'>
                    {/* {isFirst 
                        ? null 
                        : <button 
                            className='button' 
                            onClick={() => navigateto(`/difficultyproblem/${randomString1}${prevUrlAdd}`, {state:{
                                "difficultyCategoryCode": difficultyCategoryCode,
                                "problemCode": prevProblem,
                                "difficultyCategoryTitle": difficultyCategoryTitle,
                                // "improveAbilityList": improveAbilityList,
                                "dcPhase": dcPhase
                            }})}
                        >
                            이전 문제
                        </button>
                    } 
                    {isLast 
                        ? null 
                        : <button 
                            className='button' 
                            onClick={() => navigateto(`/difficultyproblem/${randomString1}${nextUrlAdd}`, {state:{
                                "difficultyCategoryCode": difficultyCategoryCode,
                                "problemCode": nextProblem,
                                "difficultyCategoryTitle": difficultyCategoryTitle,
                                // "improveAbilityList": improveAbilityList,
                                "dcPhase": dcPhase
                            }})}
                        >
                            다음 문제
                        </button>
                    }
                    <button 
                        className='button'
                        onClick={() => navigateto(`/difficultyproblem/${dcProbID}`, {state:{
                            "difficultyCategoryCode": difficultyCategoryCode,
                            "problemCode": problemCode,
                            "difficultyCategoryTitle": difficultyCategoryTitle,
                            // "improveAbilityList": improveAbilityList,
                            "dcPhase": dcPhase
                        }})}
                    >
                        문제로 돌아가기
                    </button> */}
                    <button 
                        className='button'
                        onClick={() => navigateto(`/difficultyproblem/my/${dcProbIDMy}`, {state:{
                            "difficultyCategoryCode": difficultyCategoryCode,
                            "problemCode": problemCode,
                            "difficultyCategoryTitle": difficultyCategoryTitle,
                            "problem": problem,
                            "useStat": useStat,
                            "myAnswerList": myAnswerList,
                            "isFirst": isFirst,
                            "isLast": isLast,
                            "prevProblem": prevProblem,
                            // "prevProblemId": prevProblemId,
                            "prevUrlAdd": prevUrlAdd,
                            "nextProblem": nextProblem,
                            // "nextProblemId": nextProblemId,
                            "nextUrlAdd": nextUrlAdd,
                            "dcProbID": dcProbID,
                            "myConstructionStep": myConstructionStep,
                            "myAnswerRaw":myAnswerRaw,
                            // "improveAbilityList": improveAbilityList,
                            "dcPhase": dcPhase
                        }})}
                    >
                        풀이 보기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DifficultyProblemMySolAnimation;
